import { mockCultureSubsidyApi } from './mock'
import { CultureSubsidyApi } from './types'

// Swap this export with an HTTP implementation when the backend is ready.
export const cultureSubsidyApi: CultureSubsidyApi = mockCultureSubsidyApi

export type { CultureSubsidyApi } from './types'
